import styled from '@emotion/styled'
import { colors } from '../../../../__styling/settings/colors'
import { zIndex } from '../../../../__styling/settings/z-index'
import { calcRem } from '../../../../__styling/style-functions/calc-rem'
import {
    fluidTypography,
    miniDivider,
} from '../../../../__styling/style-mixins'
import { themedValue } from '../../../../__styling/themed-value'
import { Theme } from '../../../../__styling/themes'

export const StyledRegistrationWall = styled('div')(({ theme }) => ({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    position: 'relative',
    backgroundColor: colors.thewest.westblue,
    color: colors.white,
    zIndex: zIndex.common.regWall.box,
    padding: calcRem(theme.margins.lg, 0),
}))

export const StyledRegistrationInfo = styled('div')(({ theme }) => ({
    flexBasis: calcRem(230),
    flexGrow: 1,
    padding: calcRem(0, theme.margins.lg, theme.margins.md, theme.margins.lg),
}))

const fluidRegWallTitle = (theme: Theme) =>
    themedValue(theme, {
        sevennews: fluidTypography(320, 1000, 24, 30),
        perthnow: fluidTypography(320, 1020, 24, 30),
        thewest: fluidTypography(320, 1220, 30, 40),
        fallback: undefined,
    })

export const StyledTitle = styled('h2')(({ theme }) => ({
    position: 'relative',
    margin: calcRem(0, 0, theme.margins.md, 0),
    lineHeight: 1.167,
    fontWeight: 700,
    ...fluidRegWallTitle(theme),

    // Pseudo element divider
    ...miniDivider({ theme: theme, dividerColor: colors.black }),
}))

const fluidRegWallMessage = (theme: Theme) =>
    themedValue(theme, {
        sevennews: fluidTypography(320, 1000, 16, 21),
        perthnow: fluidTypography(320, 1020, 16, 21),
        thewest: fluidTypography(320, 1220, 16, 21),
        fallback: undefined,
    })

export const StyledJoinMessage = styled('p')(({ theme }) => ({
    margin: calcRem(theme.margins.lg, 0, theme.margins.md),
    ...fluidRegWallMessage(theme),
}))
